import './aopsCommonModal.scss'

const ModalToggleButton = ({ label, isActive, onClick, isRound = false }) => {
  return (
    <div className="status-button-group">
      <button
        type="button"
        className={`status-tag ${isRound ? 'round' : ''} ${isActive ? 'active' : ''}`}
        onClick={onClick}
      >
        {label}
      </button>
    </div>
  )
}

export default ModalToggleButton
